module.exports = __webpack_public_path__ + "static/media/karlovoMes.1dd61fe1.png";